module.exports = __webpack_public_path__ + "img/icone-liquido.28d88b76.svg";